module.exports = __webpack_public_path__ + "img/gun-squirt.712f0d50.svg";